import { render } from "./tasks-sidebar.vue?vue&type=template&id=22c3b94a&scoped=true"
import script from "./tasks-sidebar.vue?vue&type=script&lang=js"
export * from "./tasks-sidebar.vue?vue&type=script&lang=js"

import "./tasks-sidebar.vue?vue&type=style&index=0&id=22c3b94a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c3b94a"]])

export default __exports__